module.exports = __webpack_public_path__ + "media/venue/webinars@2x-4943e167.png";